/**
 * Scale Drop Modal Bulk Edit – footer buttons
 * For Media Devoted | Created By Ciro Autiero
 */

import { Send, Settings2 } from 'lucide-react';
import { Button } from '@/components/ui';

export function ScaleDropModalBulkEditFooter(props: {
  onClose: () => void;
  showingLoader: boolean;
  onSave: () => void;
  onSaveAndSend?: () => Promise<void>;
  hasAnyChange: boolean;
  bulkCount: number;
  isSaveAndSendSubmitting: boolean;
  /** AI is on with a setting missing — saving it would store a drop that can
   *  never be duplicated afterwards. */
  aiSettingsIncomplete?: boolean;
}) {
  const { onClose, showingLoader, onSave, onSaveAndSend, hasAnyChange, bulkCount, isSaveAndSendSubmitting, aiSettingsIncomplete } = props;
  const blocked = showingLoader || !hasAnyChange || Boolean(aiSettingsIncomplete);
  const reason = aiSettingsIncomplete
    ? 'Fill in the AI Optimization settings, or turn AI Optimization off.'
    : undefined;
  return (
    <>
      <Button variant="outline" onClick={onClose} disabled={showingLoader}>Cancel</Button>
      {aiSettingsIncomplete && (
        <span className="mr-auto text-xs text-destructive">{reason}</span>
      )}
      {onSaveAndSend && (
        <Button onClick={onSaveAndSend} disabled={blocked} title={reason} loading={isSaveAndSendSubmitting} variant="default" className="gap-2">
          <Send className="h-4 w-4" /> Save and send
        </Button>
      )}
      <Button onClick={onSave} disabled={blocked} title={reason} className="gap-2">
        <Settings2 className="h-4 w-4" /> {bulkCount === 1 ? 'Save' : `Apply to ${bulkCount} drafts`}
      </Button>
    </>
  );
}
